import { render, staticRenderFns } from "./TablaMigration.vue?vue&type=template&id=8cd2690c&"
import script from "./TablaMigration.vue?vue&type=script&lang=js&"
export * from "./TablaMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports